import { TermosUsoComponent } from './termos-uso.component';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { LocalizeRouterModule } from '@gilsdav/ngx-translate-router';

@NgModule({
  declarations: [
    TermosUsoComponent
  ],
  imports: [
    RouterModule,
    TranslateModule,
    CommonModule,
    LocalizeRouterModule
  ],
  exports: [
    TermosUsoComponent
  ]
})

export class TermosUsoModule { }
